import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

@Injectable({ providedIn: "root" })
export class PathService {
  // #region Properties (2)

  private path: string = "";

  public redirect: boolean = false;

  // #endregion Properties (2)

  // #region Constructors (1)

  constructor() {
    console.log("Path service Constructor");
  }

  // #endregion Constructors (1)

  // #region Public Methods (3)

  public getPath(): string {
    return this.path;
  }

  public redirectNow(router: Router) {
    if (this.redirect) {
      const siteName = "/csrm-soc-e2e";
      console.log("Redirecting ......", this.path);
      const correctedUrl = this.path.replace(siteName, "");
      console.log(correctedUrl);
      router.navigateByUrl(correctedUrl);
      this.redirect = false;
    }
  }

  public setPath(path: string, redirect: boolean) {
    console.log("Setting path - " + redirect, path);
    this.path = path;
    this.redirect = redirect;
  }

  // #endregion Public Methods (3)
}
